import { IframeMessageProxy as IMP } from 'iframe-message-proxy';
import IMPConstants from '../constants/iframe-message-proxy-container';

const BASE_URI = '/contexts';
const WITH_VALUES = 'withContextValues=true';
const REQUEST_TYPE = 'text/plain';

const getAllContextData = async (identity) => {
    try {
        const contextData = await getContext(identity);
        return contextData;
    } catch {
        return [];
    }
};

const getContext = async (identity, take = 500, skip = 0) => {
    try {
        const {
            response: { items }
        } = await IMP.sendMessage({
            action: IMPConstants.Actions.SEND_COMMAND,
            content: {
                destination: IMPConstants.Destinations.MESSAGING_HUB_SERVICE,
                command: {
                    method: IMPConstants.CommandMethods.GET,
                    uri: `${BASE_URI}/${encodeURIComponent(identity)}?${WITH_VALUES}&$take=${take}&$skip=${skip}`
                }
            }
        });

        return items;
    } catch {
        return [];
    }
};

const getVariable = async (identity, variable) => {
    try {
        const { response } = await IMP.sendMessage({
            action: IMPConstants.Actions.SEND_COMMAND,
            content: {
                destination: IMPConstants.Destinations.MESSAGING_HUB_SERVICE,
                command: {
                    method: IMPConstants.CommandMethods.GET,
                    uri: `${BASE_URI}/${encodeURIComponent(identity)}/${variable}`
                }
            }
        });
        return response;
    } catch {
        return null;
    }
};

const setVariable = async (identity, variable, value) => {
    try {
        await IMP.sendMessage({
            action: IMPConstants.Actions.SEND_COMMAND,
            content: {
                destination: IMPConstants.Destinations.MESSAGING_HUB_SERVICE,
                command: {
                    method: IMPConstants.CommandMethods.SET,
                    uri: `${BASE_URI}/${encodeURIComponent(
                        identity
                    )}/${variable}`,
                    type: REQUEST_TYPE,
                    resource: value
                }
            }
        });
        return true;
    } catch {
        return false;
    }
};

const deleteAllVariables = async (identity) => {
    const variables = await getAllContextData(identity);

    await Promise.all(
        variables.map((variable) => deleteVariable(identity, variable.name))
    );
};

const deleteVariable = async (identity, variable) => {
    try {
        await IMP.sendMessage({
            action: IMPConstants.Actions.SEND_COMMAND,
            content: {
                destination: IMPConstants.Destinations.MESSAGING_HUB_SERVICE,
                command: {
                    method: IMPConstants.CommandMethods.DELETE,
                    uri: `${BASE_URI}/${encodeURIComponent(
                        identity
                    )}/${variable}`
                }
            }
        });
        return true;
    } catch {
        return false;
    }
};

export {
    getContext,
    getVariable,
    setVariable,
    deleteVariable,
    deleteAllVariables,
    getAllContextData
};
